import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// import { NgImageSliderModule } from 'ng-image-slider';
import { MatIconModule } from '@angular/material/icon';
import { JobRoutingModule } from './app-job.routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
// import { MatButtonModule } from '@angular/material/button';

import { MatRadioModule } from '@angular/material/radio';
import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
// import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { MatButtonModule } from '@angular/material/button';
// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
// import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSelectModule } from '@angular/material/select';
// import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';

import { JobHeaderComponent } from './app-job-header/app-job-header.component';
import { JobFooterComponent } from './app-job-footer/app-job-footer.component';
import { JobBlogsComponent } from './app-job-blogs/app-job-blogs.component';
import { JobTrustedComponent } from './app-job-trusted/app-job-trusted.component';
import { JobSearchComponent } from './app-job-home/app-job-search.component';
import { JobSearchResultsComponent } from './app-job-search-results/app-job-search-results.component';
import { JobPageComponent } from './app-job-detail-page/app-job-page.component';
import { JobForSchoolsComponent } from './app-job-for-schools/app-job-for-schools.component';
import { JobForTeachersComponent } from './app-job-for-teachers/app-job-for-teachers.component';
import { SharedModule } from '../shared/shared.module';
import { SitemapComponent } from '../shared/sitemap/sitemap.component';

@NgModule({
  declarations: [
    JobSearchComponent,
    JobSearchResultsComponent,
    JobPageComponent,
    JobBlogsComponent,
    JobTrustedComponent,
    JobHeaderComponent,
    JobFooterComponent,
    JobForTeachersComponent,
    JobForSchoolsComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    // NgImageSliderModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatDialogModule,
    MatExpansionModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonModule,
    MatPaginatorModule,
    JobRoutingModule,
    SharedModule,
  ],
  exports: [JobBlogsComponent],
  providers: [],
})
export class AppJobModule {}
